import ComponentPlaceholder from 'components/ComponentPlaceholder';
import type { DigizuiteAsset } from 'models/asset';
import type { Field, SitecoreBlockProps, Theme } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { filterTruthy } from 'utils/collection';
import { getAsset } from 'utils/helpers';

import ThemedIntroductionChips from './ThemedIntroductionChips';

interface Link {
	href?: string;
	text?: string;
}

interface Props extends SitecoreBlockProps {
	fields?: {
		description?: Field<string>;
		heading?: Field<string>;
		landscapeImage?: Field<DigizuiteAsset[]>;
		links?: Link[];
		theme?: Theme;
	};
}

export default function ThemedIntroductionChipsBlock({
	fields,
	params,
}: Props) {
	if (!fields) {
		return null;
	}

	const { description, heading, landscapeImage, theme } = fields;
	const links = filterTruthy(fields.links, 'href', 'text');

	if (!links?.length || !theme?.backgroundColor) {
		return (
			<ComponentPlaceholder
				className={getEditorMargin(params)}
				componentName="ThemedIntroductionChips"
				description="Requires links and a theme with a color"
			/>
		);
	}

	const topLeftImage = getAsset('Source Copy', theme.topLeftImageLandscape);
	const bottomRightImage = getAsset(
		'Source Copy',
		theme.bottomRightImageLandscape,
	);
	const centerImage = getAsset('Source Copy', landscapeImage);

	return (
		<ThemedIntroductionChips
			bottomRightImageSrc={bottomRightImage?.src}
			centerImageAlt={centerImage?.alt}
			centerImageSrc={centerImage?.src}
			className={getEditorMargin(params)}
			color={theme.backgroundColor}
			heading={heading}
			headingLevel={params?.heading}
			id={params?.anchor}
			links={links}
			text={description}
			topLeftImageSrc={topLeftImage?.src}
		/>
	);
}
ThemedIntroductionChipsBlock.displayName = 'ThemedIntroductionChipsBlock';
